module.exports = __webpack_public_path__ + "media/images/icons/outlined/down-circle-9fd5ce24e059b7be987a8caa449a4f36.svg";